export default __webpack_public_path__ + "static/media/trylleby-property-06.4358955c.jpg";